import * as React from 'react';
import { flushSync } from 'react-dom';
import {
  Upload,
  type UploadProps,
} from 'antd';
import type { UploadRequestOption } from './interface';
import AppController from '@/api/seller/Controller/AppController';
import store from '@/stores';
import { uniqueId } from 'lodash-es';
import queryString from 'query-string';

interface WebDavUploadType<Values = any> extends UploadProps<Values> {
  dragger?: boolean;
}

const WebDavUploadProps = {
  name: 'url',
  customRequest(option: UploadRequestOption) {
    const formData = new FormData();

    if (option.data) {
      Object.keys(option.data).forEach(key => {
        const value = option.data?.[key];
        // support key-value array data
        if (Array.isArray(value)) {
          value.forEach(item => {
          // { list: [ 11, 22 ] }
          // formData.append('list[]', 11);
            formData.append(`${key}[]`, item);
          });
          return;
        }

        formData.append(key, value as string | Blob);
      });
    }

    // eslint-disable-next-line no-undef
    if (option.file instanceof Blob) {
      formData.append(option.filename as string, option.file, (option.file as any).name);
    } else {
      formData.append(option.filename as string, option.file);
    }
    let abort;
    AppController.upload(formData, {
      throwError: true,
      getAbort: (fun) => abort = fun,
    }).then((res) => {
      if (res?.status == 1) {
        option.onSuccess?.({
          uid: uniqueId(),
          status: 'done',
          url: `${store.config.webDavPath}${res.data}`,
        });
      } else {
        option.onError?.(new Error(res?.info));
      }
    }).catch(e => option.onError?.(e));
    return {
      abort,
    };
  },
  onPreview(file: any) {
    if (file.url) {
      window.open(
        queryString.stringifyUrl({
          url: `${store.config.edsUrl}/App/fileDownload`,
          query: { url: file.url }
        })
      );
    }
  }
};

const WebDavUpload = (props: WebDavUploadType) => {
  if (props?.dragger) {
    return (
      <Upload.Dragger {...WebDavUploadProps}
        {...props}
        onChange={(info) => {
          flushSync(() => {
            props.onChange?.(info);
          });
        }}
      />
    );
  } else {
    return (
      <Upload {...WebDavUploadProps}
        {...props}
        onChange={(info) => {
          flushSync(() => {
            props.onChange?.(info);
          });
        }}
      />
    );
  }
};

WebDavUpload.LIST_IGNORE = Upload.LIST_IGNORE;

export default WebDavUpload;
